"use strict";
// import { tns } from "./node_modules/tiny-slider/src/tiny-slider";
Object.defineProperty(exports, "__esModule", { value: true });
var tiny_slider_1 = require("tiny-slider");
var Instance = /** @class */ (function () {
    function Instance() {
        var _this = this;
        console.log("Instance constructor");
        /* Set the width of the side navigation to 250px */
        function openNav() {
            document.getElementById("mySidenav").style.height = "100vh";
            document.getElementById("mySidenav").setAttribute("data-state", "open");
        }
        var btn = document.getElementById("menu-toggler");
        var icon1 = document.getElementById("menu-icon-a");
        var icon2 = document.getElementById("menu-icon-b");
        var icon3 = document.getElementById("menu-icon-c");
        if (btn) {
            btn.addEventListener("click", function (event) {
                event.preventDefault();
                icon1.classList.toggle("menu-icon-a");
                icon2.classList.toggle("menu-icon-c");
                icon3.classList.toggle("menu-icon-b");
                if (document.getElementById("mySidenav").getAttribute("data-state") === "open") {
                    btn.classList.remove("open");
                    closeNav();
                }
                else {
                    btn.classList.add("open");
                    openNav();
                }
            });
        }
        /* Set the width of the side navigation to 0 */
        function closeNav() {
            document.getElementById("mySidenav").style.height = "0";
            document.getElementById("mySidenav").setAttribute("data-state", "closed");
        }
        window.onload = function () {
            setTimeout(function () {
                _this.setUpFrontpageSlider();
            }, 100);
        };
    }
    Instance.prototype.setUpFrontpageSlider = function () {
        var exists = document.getElementsByClassName("exhibition-slider");
        if (exists.length <= 0) {
            console.log("No carousel initiated");
            return;
        }
        try {
            var slider_1 = (0, tiny_slider_1.tns)({
                container: '.exhibition-slider__block',
                // mode: 'carousel',
                // axis: 'horizontal',
                // center: true,
                autoWidth: true,
                // loop: true,
                // items: 1,
                // responsive: {
                //     640: {
                //         edgePadding: 20,
                //         gutter: 20,
                //         items: 1
                //     },
                //     700: {
                //         gutter: 30,
                //         items: 2
                //     },
                //     900: {
                //         items: 3
                //     }
                // },
                // touch: true,
                // autoplay: true,
                loop: true,
                items: 1,
                slideBy: 'page',
                nav: false,
                autoplay: true,
                touch: true,
                speed: 400,
                autoplayButtonOutput: false,
                mouseDrag: false,
                lazyload: true,
                controlsText: ['Previous', 'Next'],
                controlsContainer: '#exhibition-slider__controls',
                prevButton: '#slider-prev',
                nextButton: '#slider-next',
                autoplayButton: '#slider-autoplay',
                // controlsContainer: "#customize-controls",
                responsive: {
                    640: {
                        items: 2,
                    },
                    768: {
                        items: 3,
                    }
                }
            });
            slider_1
                .getInfo()
                .slideItems[slider_1.getInfo().index].classList.add("vl-slide-center");
            slider_1.events.on("indexChanged", function () {
                try {
                    var info = slider_1.getInfo();
                    var indexCurr = info.index;
                    var elements = document.getElementsByClassName("vl-slide-center");
                    while (elements.length > 0) {
                        elements[0].classList.remove("vl-slide-center");
                    }
                    if (info.slideItems[indexCurr]) {
                        info.slideItems[indexCurr].classList.add("vl-slide-center");
                    }
                }
                catch (error) {
                    console.error("Slider issue", error);
                }
            });
        }
        catch (error) {
            console.error(error);
        }
    };
    return Instance;
}());
exports.default = Instance;
